/**
 * Checks if a JWT token has expired.
 * @param {Object} jwt - The decoded JWT object containing token claims.
 * @param {number} jwt.exp - The expiration time (in seconds since Unix epoch).
 * @returns {boolean} True if the token has expired, false otherwise.
 */
export const jwtExpired = jwt => jwt?.exp < Math.floor(Date.now() / 1000);

/**
 * Decodes a JWT token and returns the payload.
 * @param {string} token - The JWT token string to decode.
 * @returns {Object|null} The decoded payload object, or null if the token is invalid or decoding fails.
 */
export const decodeJWT = token => {
  if (!token) {
    return null;
  }
  try {
    const [, payload] = token.split('.');
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};
